import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { businessAdminRouter } from './routing/businessAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { BusinessProgramRead } from './access-control/businessAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'business',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'business-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
  },
  routers: {
    admin: [businessAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Merchandising,
      subNavItems: [
        {
          route: 'app-admin-business-program-list',
          labelId: 'businessDomain.businessPrograms.title',
          accessControl: BusinessProgramRead,
          positionNavV2: 3,
        },
      ],
    },
  ],
}

export default definition
